import { useState } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      quote: "Alwaz Travel made our family trip to Makkah and Madinah absolutely stress-free. Every accommodation was perfectly chosen, close to the Haram, and our advisor was available 24/7. We felt truly cared for throughout the entire journey.",
      author: "Fatima & Ahmed K.",
      location: "London",
      image: "https://public.readdy.ai/ai/img_res/5d34ae31276a07fe06cc8b2962addf75.jpg"
    },
    {
      quote: "The attention to detail was exceptional. From halal dining options to prayer facilities, everything was thoughtfully arranged. Our group of 12 had the most memorable experience in Turkey, thanks to Alwaz Travel's expertise.",
      author: "Yusuf & Sarah M.",
      location: "Birmingham",
      image: "https://readdy.ai/api/search-image?query=Muslim%20couple%20in%20their%2040s%20smiling%20together%20wearing%20modest%20Islamic%20attire%2C%20professional%20portrait%20photography%2C%20warm%20and%20friendly%20expressions%2C%20natural%20lighting%2C%20contemporary%20style%2C%20authentic%20and%20genuine%2C%20high%20quality%20portrait%2C%20cultural%20respect&width=600&height=800&seq=couple-testimonial-002&orientation=portrait"
    },
    {
      quote: "As first-time travellers to the Middle East, we were nervous. But Alwaz Travel guided us every step of the way. The accommodations were luxurious yet culturally appropriate, and the service was impeccable.",
      author: "Aisha & Ibrahim R.",
      location: "Manchester",
      image: "https://readdy.ai/api/search-image?query=Young%20Muslim%20couple%20in%20their%2030s%20with%20happy%20expressions%20wearing%20modern%20modest%20Islamic%20clothing%2C%20professional%20portrait%2C%20natural%20warm%20lighting%2C%20contemporary%20photography%20style%2C%20genuine%20smiles%2C%20high%20quality%20portrait%2C%20cultural%20authenticity&width=600&height=800&seq=young-couple-testimonial-003&orientation=portrait"
    }
  ];

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-2">
            <div className="w-full h-[600px] rounded-3xl overflow-hidden shadow-2xl">
              <img
                src={testimonials[currentIndex].image}
                alt={testimonials[currentIndex].author}
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="text-gray-500 text-sm mb-4">(Trusted by families across Europe)</p>
            
            <h2 className="text-5xl lg:text-6xl font-bold text-[#1A1F2E] mb-4 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Seamless planning,
            </h2>
            <h3 className="text-5xl lg:text-6xl font-bold text-gray-400 mb-12 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              unforgettable memories
            </h3>

            <div className="mb-12">
              <p className="text-xl text-gray-700 leading-relaxed mb-8 italic">
                "{testimonials[currentIndex].quote}"
              </p>
              <p className="text-lg font-bold text-[#1A1F2E]">
                — {testimonials[currentIndex].author}, {testimonials[currentIndex].location}
              </p>
            </div>

            <div className="flex items-center gap-4">
              <button
                onClick={handlePrev}
                className="w-12 h-12 rounded-full border-2 border-gray-300 flex items-center justify-center hover:border-[#C9A961] hover:text-[#C9A961] transition-all cursor-pointer"
                aria-label="Previous testimonial"
              >
                <i className="ri-arrow-left-line text-xl"></i>
              </button>
              <button
                onClick={handleNext}
                className="w-12 h-12 rounded-full bg-[#C9A961] flex items-center justify-center hover:bg-[#B89851] transition-all cursor-pointer"
                aria-label="Next testimonial"
              >
                <i className="ri-arrow-right-line text-xl text-white"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
